// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-ManageTB-Box-styles___box--pcOtg {
  width: 352px;
  height: 150px;
  margin-right: 30px;
  cursor: pointer;
}

.components-ManageTB-Box-styles___boxTextContainer--RA4dn {
  padding: 40px;
  background: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(109, 113, 122, 0.2);
  border-radius: 6px;
  background: #ffffff;
  display: flex;
  align-items: center;
}

.components-ManageTB-Box-styles___textStyle--N84eb {
  font-size: 21px;
  color: #1b2432;
  letter-spacing: 0;
  font-weight: 600;
  font-family: 'Roboto';
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.components-ManageTB-Box-styles___iconStyle--slRro {
  margin-right: 25px;
}

.components-ManageTB-Box-styles___description--tVDoI {
  font-family: 'Roboto';
  font-size: 13px;
  color: #6d717a;
  letter-spacing: 0;
  width: 192px;
  text-align: start;
  margin-top: 7px;
}
`, "",{"version":3,"sources":["webpack://./components/ManageTB/Box/styles.pcss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gDAAgD;EAChD,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".box {\n  width: 352px;\n  height: 150px;\n  margin-right: 30px;\n  cursor: pointer;\n}\n\n.boxTextContainer {\n  padding: 40px;\n  background: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(109, 113, 122, 0.2);\n  border-radius: 6px;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n}\n\n.textStyle {\n  font-size: 21px;\n  color: #1b2432;\n  letter-spacing: 0;\n  font-weight: 600;\n  font-family: 'Roboto';\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.iconStyle {\n  margin-right: 25px;\n}\n\n.description {\n  font-family: 'Roboto';\n  font-size: 13px;\n  color: #6d717a;\n  letter-spacing: 0;\n  width: 192px;\n  text-align: start;\n  margin-top: 7px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `components-ManageTB-Box-styles___box--pcOtg`,
	"boxTextContainer": `components-ManageTB-Box-styles___boxTextContainer--RA4dn`,
	"textStyle": `components-ManageTB-Box-styles___textStyle--N84eb`,
	"iconStyle": `components-ManageTB-Box-styles___iconStyle--slRro`,
	"description": `components-ManageTB-Box-styles___description--tVDoI`
};
module.exports = ___CSS_LOADER_EXPORT___;
